<template>
  <div>
    <h1>Load Requesters</h1>
    <div>
      <b-card no-body>
        <form ref="form" @submit.prevent="submit">
          <b-row v-if="isUserAdmin()" class="m-2">
            <b-col>
              <b-form-group
                      :state="$v.file.$dirty ? !$v.file.$error : null"
                      label="File"
                      label-for="file-input"
                      invalid-feedback="File Attachment is required">
                <b-form-file
                        id="file-input"
                        v-model="file"
                        :state="$v.file.$dirty ? !$v.file.$error : null"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here...">
                </b-form-file>
              </b-form-group>

              <b-button type="submit" variant="primary" @click="submit">Submit</b-button>
            </b-col>
          </b-row>
          <b-row v-if="!isUserAdmin()">
            <b-col>
              <p>You do not have access to this function</p>
            </b-col>
          </b-row>
        </form>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'
import { roleService } from "@/mixins/roleService.js";

export default {
  mixins: [
    roleService
  ],
  data: () => ({
    file: null
  }),
  methods: {
    submit() {
      const fd2 = new FormData()
      fd2.append('file', this.file)
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/roles/load`, fd2, {params :{form: true}})
        .then(response => {
          this.file = null
          this.$bvToast.toast('Users Updated', {
            title: 'Status',
            toaster: 'b-toaster-top-center',
            solid: true,
            variant: 'success',
            appendToast: true
          })
        })
    }
  },
  validations() {
    return {
      file: { required }
    }
  }
}
</script>

<style lang="scss">
  .tab-title-class {  //overwrite default text color for accessibility purposes
    color: #2c3e50;
  }
</style>